module.exports = __webpack_public_path__ + "media/gsacover.c042e5fb.mp3";